var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.65502V36.0624C0 36.9894 0.95 37.6292 1.825 37.2847L13.3333 32.1249V0.624945L1.675 5.2187C1.18055 5.41368 0.756753 5.74995 0.458215 6.18418C0.159678 6.61841 8.40624e-05 7.1307 0 7.65502ZM16 32.1249L32 37.3749V5.87495L16 0.624945V32.1249ZM46.175 0.723383L34.6667 5.87495V37.3749L46.325 32.7812C46.8195 32.5862 47.2432 32.2499 47.5418 31.8157C47.8403 31.3815 47.9999 30.8692 48 30.3449V1.93745C48 1.01049 47.05 0.370648 46.175 0.71518V0.723383Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.f9e8a85d0e4568b87c306c04c567bd25.svg";
export { ForwardRef as ReactComponent };